import {AccountMin} from "platformed-client/types";
import {HTTPError} from "platformed-client";
import externalApi from "../../../api/external";
import {param, typedQuery} from "../../typing";
import {setLanguage} from "../../../App/i18n";

export const whoAmI = typedQuery(["external", "whoAmI", param<AccountMin>("account")], async account => {
  const result = await externalApi.auth.whoAmI(account);

  if (result.user.language_code) {
    setLanguage(result.user.language_code);
  }

  return result;
});

export const isLoggedIn = typedQuery(["external", "isLoggedIn", param<AccountMin>("account")], async account => {
  try {
    await externalApi.auth.whoAmI(account);
    return true;
  } catch (ex) {
    if (ex instanceof HTTPError && ex.response.status === 401) {
      return false;
    }
    throw ex;
  }
});
